export const footerMoreLinks = {
  'kz-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://kz.wingie.com/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://kz.wingie.com/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://kz.wingie.com/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://kz.wingie.com/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://kz.wingie.com/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://kz.wingie.com/awards/',
          title: 'Награды',
        },
      ],
    },
  ],
  'kz-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://kz.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://kz.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://kz.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://kz.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kz.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://kz.wingie.com/en/awards/',
          title: 'Awards',
        },
      ],
    },
  ],
  'kz-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://kz.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://kz.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://kz.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://kz.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://kz.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://kz.wingie.com/es/awards/',
          title: 'Premios',
        },
      ],
    },
  ],
  'kz-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://kz.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://kz.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen',
        },

        {
          href: 'https://kz.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://kz.wingie.com/de/datenschutz/',
          title: 'Datenschutz',
        },
        {
          href: 'https://kz.wingie.com/de/allgemeine-geschaftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://kz.wingie.com/de/awards/',
          title: 'Preise',
        },
      ],
    },
  ],
  'kz-ar': [
    {
      title: 'المزيد',
      items: [
        {
          href: 'https://kz.wingie.com/ar/contact/',
          title: 'اتصل بنا',
        },
        {
          href: 'https://kz.wingie.com/ar/faq/',
          title: 'الأسئلة الشائعة',
        },

        {
          href: 'https://kz.wingie.com/ar/about-us/',
          title: 'من نحن',
        },
        {
          href: 'https://kz.wingie.com/ar/privacy/',
          title: 'الخصوصية',
        },
        {
          href: 'https://kz.wingie.com/ar/terms-and-conditions/',
          title: 'الشروط والأحكام',
        },
        {
          href: 'https://kz.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'kz-it': [
    {
      title: 'Altro',
      items: [
        {
          href: 'https://kz.wingie.com/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://kz.wingie.com/it/faq/',
        //     title: 'Domande Frequenti',
        // },

        {
          href: 'https://kz.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://kz.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kz.wingie.com/it/terms-and-conditions/',
          title: 'Termini e Condizioni',
        },
        {
          href: 'https://kz.wingie.com/it/awards/',
          title: 'Premi',
        },
      ],
    },
  ],
  'kz-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://kz.wingie.com/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kz.wingie.com/fr/faq/',
        //     title: 'Questions Fréquemment Posées',
        // },

        {
          href: 'https://kz.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://kz.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://kz.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et Conditions',
        },
        {
          href: 'https://kz.wingie.com/fr/awards/',
          title: 'Prix',
        },
      ],
    },
  ],
  'kz-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://kz.wingie.com/pt/contact/',
          title: 'Contacto',
        },
        // {
        //     href: 'https://kz.wingie.com/pt/faq/',
        //     title: 'Perguntas Frequentes',
        // },

        {
          href: 'https://kz.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://kz.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://kz.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e Condições',
        },
        {
          href: 'https://kz.wingie.com/pt/awards/',
          title: 'Prémios',
        },
      ],
    },
  ],
  'kz-ro': [
    {
      title: 'Mai Mult',
      items: [
        {
          href: 'https://kz.wingie.com/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kz.wingie.com/ro/faq/',
        //     title: 'Întrebări Frecvente',
        // },

        {
          href: 'https://kz.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://kz.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://kz.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și Condiții',
        },
        {
          href: 'https://kz.wingie.com/ro/awards/',
          title: 'Premii',
        },
      ],
    },
  ],
  'kz-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://kz.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://kz.wingie.com/pl/faq/',
        //     title: 'Często Zadawane Pytania',
        // },

        {
          href: 'https://kz.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://kz.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://kz.wingie.com/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://kz.wingie.com/pl/awards/',
          title: 'Nagrody',
        },
      ],
    },
  ],
  'kz-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://kz.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://kz.wingie.com/lt/faq/',
        //     title: 'Dažnai Užduodami Klausimai',
        // },

        {
          href: 'https://kz.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://kz.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://kz.wingie.com/lt/terms-and-conditions/',
          title: 'Taisyklės ir Sąlygos',
        },
        {
          href: 'https://kz.wingie.com/lt/awards/',
          title: 'Prizai',
        },
      ],
    },
  ],
  'kz-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://kz.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://kz.wingie.com/uz/faq/',
        //     title: 'Tez-tez Beriladigan Savollar',
        // },

        {
          href: 'https://kz.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://kz.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://kz.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va Qoidalar',
        },
        {
          href: 'https://kz.wingie.com/uz/awards/',
          title: 'Mukofotlar',
        },
      ],
    },
  ],
  'kz-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://kz.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://kz.wingie.com/sr/faq/',
        //     title: 'Честа питања',
        // },

        {
          href: 'https://kz.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://kz.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://kz.wingie.com/sr/terms-and-conditions/',
          title: 'Услови коришћења',
        },
        {
          href: 'https://kz.wingie.com/sr/awards/',
          title: 'Награде',
        },
      ],
    },
  ],
  'kz-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://kz.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://kz.wingie.com/ky/faq/',
        //     title: 'Жыйнак суроолор',
        // },

        {
          href: 'https://kz.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://kz.wingie.com/ky/privacy/',
          title: 'Купуялуулук',
        },
        {
          href: 'https://kz.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана Талаптар',
        },
        {
          href: 'https://kz.wingie.com/ky/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'kz-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://kz.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://kz.wingie.com/tg/faq/',
        //     title: 'Саволҳои зиёд',
        // },

        {
          href: 'https://kz.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://kz.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://kz.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва шароитҳо',
        },
        {
          href: 'https://kz.wingie.com/tg/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'kz-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://kz.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://kz.wingie.com/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },

        {
          href: 'https://kz.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://kz.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://kz.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://kz.wingie.com/kk/awards/',
          title: 'Біздің марапаттарымыз',
        },
      ],
    },
  ],
  'kz-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://kz.wingie.com/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kz.wingie.com/nl/faq/',
        //     title: 'Veelgestelde Vragen',
        // },

        {
          href: 'https://kz.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://kz.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kz.wingie.com/nl/terms-and-conditions/',
          title: 'Voorwaarden',
        },
        {
          href: 'https://kz.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'kz-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://kz.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://kz.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://kz.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://kz.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://kz.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://kz.wingie.com/ja/awards/' },
      ],
    },
  ],
  'kz-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://kz.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://kz.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://kz.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://kz.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://kz.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://kz.wingie.com/zh/awards/' },
      ],
    },
  ],
  'kz-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://kz.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://kz.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://kz.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://kz.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://kz.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://kz.wingie.com/ko/awards/' },
      ],
    },
  ],
  'kz-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://kz.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://kz.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://kz.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://kz.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://kz.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://kz.wingie.com/hi/awards/' },
      ],
    },
  ],
  'kz-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://kz.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://kz.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://kz.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://kz.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://kz.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://kz.wingie.com/ta/awards/' },
      ],
    },
  ],
  'kz-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://kz.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://kz.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://kz.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://kz.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://kz.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://kz.wingie.com/th/awards/' },
      ],
    },
  ],
  'kz-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://kz.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://kz.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://kz.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://kz.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://kz.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://kz.wingie.com/ur/awards/' },
      ],
    },
  ],
  'kz-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://kz.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://kz.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://kz.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://kz.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://kz.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://kz.wingie.com/ka/awards/' },
      ],
    },
  ],
}
